module.exports = __webpack_public_path__ + "static/media/addexistingregistry_548x260.00a5a86d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/addexistingregistry_548x260.jpg
// module id = 1498
// module chunks = 43